<template>
    <div>
        <PrestataireHeader />
    </div>
</template>
<script>
import PrestataireHeader from '@/components/Billeterie/PageMove/PrestataireHeader.vue'
export default {

    components: {
        PrestataireHeader,
    }

}
</script>


<style scoped>

</style>
